export const initButtons = () => {
	wrapFancyButtonsTextWithSpan();
	// convertSubmitButtons();
};

const wrapFancyButtonsTextWithSpan = () => {
	const fancyButtons = document.querySelectorAll(".fancy-btn");

	fancyButtons.forEach((button) => {
		// Now handle wrapping the text node in a span
		if (!button.querySelector(".text")) {
			// Filter for actual text nodes that have non-whitespace characters
			const textNodes = [...button.childNodes].filter((node) => {
				return node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0;
			});

			if (textNodes.length > 0) {
				// Wrap each text node in a span with class "text"
				textNodes.forEach((textNode) => {
					const span = document.createElement("span");
					span.classList.add("text");
					span.textContent = textNode.textContent; // Set the text content inside the span
					textNode.replaceWith(span);
				});
			}
		}

		// Check if the button contains an icon
		if (button.classList.contains("icon-btn")) {
			// If the icon is already wrapped, skip
			if (button.querySelector(".icon")) return;

			// Check for an SVG element inside the button
			const svg = button.querySelector("svg");
			// If an SVG is found and not wrapped, wrap it in a span
			if (svg && !svg.closest("span.icon")) {
				const span = document.createElement("span");
				span.classList.add("icon");
				svg.replaceWith(span);
				span.appendChild(svg);
			} else if (!svg) {
				// if no svg is found that means that either the dev forgot to include
				// one in the template or the icon name wasn't found
				// so lets just default to using the up right arrow svg
				const span = document.createElement("span");
				span.classList.add("icon");
				span.innerHTML = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 17L17 7" stroke="#B6D4F8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 7h10v10" stroke="#B6D4F8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
				button.prepend(span);
			}
		}
	});
};

// convert submit buttons into a ".fancy-btn" and ".icon-btn"
const convertSubmitButtons = () => {
	if (!document.querySelector("[type='submit']")) return;
	console.log("Converting submit buttons...");
	const submitButtons = document.querySelectorAll("[type='submit']");
	submitButtons.forEach((button) => {
		button.classList.add("fancy-btn", "icon-btn");
	});
};
